import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import * as _ser from "../../../_redux/_services/ApplicantsSlice";
import GetJobId from "../../../_utilities/GetJobId";
import { getWorkonDate } from "../../../_utilities/GetTimeZone";
import { decrypt, Encrypt } from "../../../_utilities/_encryptDecryptHelper";
import { setBreadCrumb } from "../../../_utilities/breadCrumb";
import {
  getAttributes,
  getUserDetails,
  GetUserInfo,
} from "../../../_utilities/getUserInfo";
import ApplicantsComponent from "../ApplicantsComponent";
import { safeJSONParse } from "../../../_utilities/constants";
import { refreshOutlet } from "../../../_redux/Uislice";

const initalState = { data: null, message: "", isloader: true };

const ApplicantsEdit = ({}) => {
  const [getDetails, setGetDetails] = useState(initialDetails);
  const getJobCode = GetJobId();
  const [disableSubmitBtn, setDisableSubmitBtn] = useState(false);
  const [overwrideObj, setOverwrideObj] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    console.log(overwrideObj);
  }, [overwrideObj]);

  const ApplicantData = useSelector((state) => state.ApplicantsById.data);
  const PrimaryDocumentRes = useSelector((state) => state.SetPrimaryDocument.data);
  const selectedJobDetails = useSelector(
    (state) => state.SetSelectedJobDetails.data,
  );
  const DocId = useSelector((state) => state.UploadDocuments.docId);

  useEffect(() => {
    if (getJobCode !== null) {
      dispatch(_ser.applicantsByIdAsync(getJobCode));
    }
  }, [getJobCode, dispatch]);
    
  useEffect(() => {
    if (location.state?.applicant && location.state.isOverwriteEdit) {
      let newObj = location.state.applicant;
      let educationObj = newObj.educationDetails;
      if (educationObj && educationObj.length > 0) {
        educationObj.forEach((item, i) => {
          item["id"] = i;
          item["isEdit"] = false;
          item["startDate"] =
            item?.startDate && item.startDate
              ? new Date(item?.startDate).toLocaleDateString()
              : "";
          item["endDate"] =
            item?.endDate && item.endDate
              ? new Date(item?.endDate).toLocaleDateString()
              : "";
          if (item?.education) {
            item["degree"] = item.education;
          }
        });
      }
      let workExpObj = newObj.workExp || newObj.workExperiences;
      if (workExpObj && workExpObj.length > 0) {
        workExpObj.forEach((item, i) => {
          item["id"] = i;
          item["isEdit"] = false;
          item["locationFormated"] = item?.location?.formatted;
          item["startDate"] =
            item?.startDate && item.startDate
              ? new Date(item?.startDate).toLocaleDateString()
              : "";
          item["endDate"] =
            item?.endDate && item.endDate
              ? new Date(item?.endDate).toLocaleDateString()
              : "";
        });
      }
      newObj["educationDetails"] = educationObj;
      newObj["workExp"] = workExpObj;
      newObj["Applicants"]["contactNumber"] = newObj.Applicants?.contactNumber
        ? newObj.Applicants?.contactNumber
        : newObj.Applicants?.phone
          ? newObj.Applicants.phone
          : "";
      newObj["Applicants"]["resumesourceId"] = newObj.resumesource
        ? newObj.resumesource
        : newObj.sourceId?.id
          ? newObj.sourceId?.id
          : newObj.Applicants?.resumesourceId;
      newObj["Applicants"]["resumesource"] = newObj.resumesource
        ? newObj.resumesource
        : newObj.sourceId?.name
          ? newObj.sourceId?.name
          : newObj.Applicants?.resumesourceId;
      newObj["Applicants"]["candidateStatus"] = newObj.Applicants
        ?.candidateStatus
        ? newObj.Applicants?.candidateStatus
        : "";
      newObj["applicantCode"] = newObj?.applicantCode
        ? newObj?.applicantCode
        : ApplicantData && ApplicantData[0]?.applicantCode;
      newObj["identifier"] = newObj.identifier;
      newObj["rawData"] = newObj?.rawData ?? "";
      newObj["formattedLocation"] = newObj?.formattedLocation ?? newObj?.locationData?.formatted ?? "";
      newObj["locationRawInput"] = newObj?.locationRawInput ?? newObj?.locationData?.locationRawInput ?? "";
      newObj["latitude"] = newObj?.latitude ?? newObj?.locationData?.latitude ?? null;
      newObj["longitude"] = newObj?.longitude ?? newObj?.locationData?.longitude ?? null;
      newObj["locationCity"] = newObj?.locationCity ?? newObj?.locationData?.city ?? "";
      newObj["locationCountry"] = newObj?.locationCountry ?? newObj?.locationData?.country ?? "";
      newObj["locationState"] = newObj?.locationState ?? newObj?.locationData?.state ?? "";
      localStorage.setItem("OverwriteEditObj", JSON.stringify(newObj));
      setOverwrideObj(newObj);
      // for navsidebar
      let designation =
        workExpObj?.length > 0
          ? `${workExpObj[0]?.jobTitle || ""}${workExpObj[0]?.organization ? " / " + workExpObj[0]?.organization : ""}`
          : "";
      let expObject = workExpObj[0]?.experienceInMonths
        ? workExpObj[0]?.experienceInMonths
        : {
            startDate: workExpObj[0]?.startDate,
            endDate: Boolean(workExpObj[0]?.isCurrent)
              ? "present"
              : workExpObj[0]?.endDate,
          };
      let additionalData = {
        applicantName: `${newObj.Applicants.firstName} ${newObj.Applicants.lastName}`,
        currentWorking: {
          designation: designation,
          from: getWorkonDate(expObject, "level2"),
        },
        emailId: newObj.Applicants?.emailId,
        contactNumber:
          newObj.Applicants?.contactNumber || newObj.Applicants?.phone,
        alternateContactNumber: newObj.Applicants?.alternateContactNumber || "",
        linkedIn: newObj.linkedIn ?? "",
        location:
          newObj.Applicants.location ||
            newObj?.formattedLocation?.trim() ||
              [newObj?.locationCity, newObj?.locationState, newObj?.locationCountry]
              .filter(Boolean).join(", "),
      };
      setBreadCrumb(
        newObj.id,
        additionalData.applicantName,
        "Applicant Code",
        additionalData,
      );
    }
  }, [location, ApplicantData]);

  useEffect(() => {
    if (ApplicantData !== null && ApplicantData.length > 0) {
      let initobj = JSON.parse(JSON.stringify(initialDetails));
      let myData = JSON.parse(JSON.stringify(ApplicantData));
      initobj.Applicants.firstName = myData[0].firstName;
      initobj.Applicants.lastName = myData[0].lastName;
      initobj.Applicants.contactNumber = myData[0].contactNumber;
      initobj.Applicants.alternateContactNumber =
        myData[0].alternateContactNumber;
      initobj.Applicants.emailId = myData[0].emailId;
      initobj.Applicants.resumesourceId = myData[0].resumesourceId;
      initobj.Applicants.candidateStatus = myData[0].candidateStatus;
      initobj.source = myData[0].source;
      initobj.applicantCode = myData[0].applicantCode;
      initobj.customFields = myData[0].customFields;
      initobj.formattedLocation = myData[0].formattedLocation;
      initobj.locationCity = myData[0].locationCity;
      initobj.locationCountry = myData[0].locationCountry;
      initobj.locationState = myData[0].locationState;
      initobj.locationRawInput = myData[0].locationRawInput;
      initobj.linkedIn = myData[0].linkedIn;
      initobj.latitude = myData[0].latitude;
      initobj.rawData = myData[0].rawData;
      initobj.longitude = myData[0].longitude;
      let educationObj = JSON.parse(myData[0].educationDetails);
      educationObj = safeJSONParse(educationObj)?.filter((item) => {
        return Object.values(item).some((val) => {
          if (typeof val === "string") {
            return val.trim() !== "";
          }
          return false;
        });
      });
      if (educationObj !== null && educationObj?.length > 0) {
        educationObj?.forEach((item, i) => {
          item["id"] = i;
          item["isEdit"] = false;
          item["startDate"] =
            item?.startDate && item.startDate
              ? new Date(item?.startDate).toLocaleDateString()
              : "";
          item["endDate"] =
            item?.endDate && item.endDate
              ? new Date(item?.endDate).toLocaleDateString()
              : "";
          if (item?.education) {
            item["degree"] = item.education;
          }
        });
      }
      initobj.educationDetails =
        educationObj && educationObj?.length > 0 ? educationObj : [];
      let workExpObj = JSON.parse(myData[0].workExp) || [];
      workExpObj = safeJSONParse(workExpObj)?.filter((item) => {
        return Object.values(item).some((val) => {
          if (typeof val === "string") {
            return val.trim() !== "";
          }
          return false;
        });
      });
      if (workExpObj !== null && workExpObj?.length > 0) {
        workExpObj?.forEach((item, i) => {
          item["id"] = i;
          item["isEdit"] = false;
          item["locationFormated"] = item?.location?.formatted;
          item["startDate"] =
            item?.startDate && item.startDate
              ? new Date(item?.startDate).toLocaleDateString()
              : "";
          item["endDate"] =
            item?.endDate && item.endDate
              ? new Date(item?.endDate).toLocaleDateString()
              : "";
        });
      }
      initobj.workExp = workExpObj && workExpObj.length > 0 ? workExpObj : [];
      initobj.skillDetails = myData[0].skillDetails
        ? JSON.parse(myData[0].skillDetails)
        : [];
      initobj.certification =
        myData[0].certification && myData[0].certification !== "undefined"
          ? JSON.parse(myData[0].certification)
          : [];
      initobj.id = myData[0].id;
      initobj.totalExperience = myData[0].totalExperience;
      initobj.linkedIn = myData[0].linkedIn ?? "";
      initobj.identifier = myData[0].affindaIdentifier;
      let OverwriteEditObj = localStorage.getItem("OverwriteEditObj");
      if (overwrideObj !== null) {
        overwrideObj.Applicants.resumesourceId = myData[0].resumesourceId;
        overwrideObj.source = myData[0].source;
        setGetDetails(overwrideObj);
      } else if (OverwriteEditObj) {
        setOverwrideObj(JSON.parse(OverwriteEditObj));
        setGetDetails(JSON.parse(OverwriteEditObj));
      } else {
        setGetDetails(initobj);
      }
      dispatch(_ser.applicantsByIdStartReducer(initalState));
      let designation =
        initobj?.workExp.length > 0
          ? `${initobj.workExp[0]?.title || initobj.workExp[0]?.jobTitle || ""}${initobj?.workExp?.organization ? " / " + initobj.workExp?.organization : ""}`
          : "";
      let expObject = initobj.workExp[0]?.experienceInMonths
        ? initobj.workExp[0]?.experienceInMonths
        : {
            startDate: initobj.workExp[0]?.startDate,
            endDate: Boolean(initobj.workExp[0]?.isCurrent)
              ? "present"
              : initobj.workExp[0]?.endDate,
          };
      let additionalData = {
        applicantName: initobj.Applicants.firstName,
        currentWorking: {
          designation: designation,
          from: getWorkonDate(expObject, "level2"),
        },
        emailId: initobj.Applicants.emailId,
        contactNumber: initobj.Applicants.contactNumber,
        alternateContactNumber: initobj.Applicants.alternateContactNumber,
        linkedIn: initobj.linkedIn ?? "",
        location: initobj?.formattedLocation?.trim() || 
          [initobj?.locationCity, initobj?.locationState, initobj?.locationCountry]
              .filter(Boolean).join(", "),
      };
      setBreadCrumb(
        myData[0].id,
        myData[0].fullName,
        "Applicant Code",
        additionalData,
      );
    }
  }, [ApplicantData]);

  const Editdata = useSelector((state) => state.EditApplicants.data);

  const GetValidData = async (data) => {
    const userData = await GetUserInfo();
    // dispatch(_ser.setSelectedJobDetailsStartReducer(initalState));
    let finalObj = data;
    finalObj = { ...data, ...data.Applicants };
    finalObj["id"] = getJobCode;
    finalObj.educationDetails = JSON.stringify(data.educationDetails);
    finalObj.workExp = JSON.stringify(data.workExp);
    finalObj.certification = JSON.stringify(data.certification);
    finalObj.skillDetails = JSON.stringify(data.skillDetails);
    finalObj.customFields = data.customFields;
    finalObj.applicantCode = data && data.applicantCode;
    const userInfo = await getUserDetails();
    finalObj["userFirstName"] = userInfo.firstName
      ? userInfo.firstName
      : data.firstName;
    finalObj["userLastName"] = userInfo.lastName
      ? userInfo.lastName
      : data.lastName;
    finalObj["userId"] = userInfo.userId;
    finalObj["linkedIn"] = data.linkedIn ?? "";
    finalObj["formattedLocation"] = data?.formattedLocation ?? "";
    finalObj["locationCity"] = data?.locationCity ?? "";
    finalObj["locationCountry"] = data?.locationCountry ?? "";
    finalObj["locationState"] = data?.locationState ?? "";
    finalObj["locationRawInput"] = data?.locationRawInput ?? "";
    finalObj["latitude"] = data?.latitude ?? "";
    finalObj["rawData"] = data?.rawData ?? "";
    finalObj["longitude"] = data?.longitude ?? "";
    dispatch(_ser.editApplicantsAsync(getJobCode, finalObj))
      .then(() => {
        setDisableSubmitBtn(false);
      })
      .catch(() => {
        setDisableSubmitBtn(false);
      });
    if (overwrideObj !== null) {
      const userInfo = await getUserDetails();
      if (overwrideObj.Resume && overwrideObj.Applicants.resumesourceId) {
        let formData = new FormData();
        formData.append("Resume", overwrideObj.Resume);
        formData.append("id", getJobCode);
        formData.append("userId", userInfo.userId);
        formData.append("DbUserId", userData[0].userId);
        formData.append("ResumeUserId", userData[0].userId);
        formData.append("fileType", "Resume");
        formData.append(
          "resumesourceId",
          overwrideObj.Applicants.resumesourceId,
        );
        formData.append("resumesource", overwrideObj.Applicants.resumesource);
        formData.append("userFirstName", userInfo.firstName);
        formData.append("userLastName", userInfo.lastName);
        formData.append("linkedIn", overwrideObj.linkedIn ?? "");
        formData.append("primaryResume", 1);
        formData.append(
          "formattedLocation",
          overwrideObj.formattedLocation ?? "",
        );
        formData.append("locationCity", overwrideObj.locationCity ?? "");
        formData.append("locationCountry", overwrideObj.locationCountry ?? "");
        formData.append("locationState", overwrideObj.locationState ?? "");
        formData.append(
          "locationRawInput",
          overwrideObj.locationRawInput ?? "",
        );
        formData.append("latitude", overwrideObj.latitude ?? "");
        formData.append("rawData", overwrideObj.rawData ?? "");
        formData.append("longitude", overwrideObj.longitude ?? "");
        dispatch(_ser.uploadDocumentsAsync(getJobCode, formData, true));
      } else {
        //  for making document as primary
        let formData = new FormData();
        formData.append("applicantId", getJobCode);
        formData.append(
          "applicantCode",
          location.state?.applicant.applicantCode,
        );
        formData.append("userId", userInfo.userId);
        dispatch(_ser.setPrimaryDocumentAsync(location.state?.docId, formData));
      }
      setOverwrideObj(null);
    }
    let designation =
      data.workExp?.length > 0
        ? `${data.workExp[0]?.jobTitle || ""}${data.workExp[0]?.organization ? " / " + data.workExp[0]?.organization : ""}`
        : "";
    let expObject = data.workExp[0]?.experienceInMonths
      ? data.workExp[0]?.experienceInMonths
      : {
          startDate: data.workExp[0]?.startDate,
          endDate: Boolean(data.workExp[0]?.isCurrent)
            ? "present"
            : data.workExp[0]?.endDate,
        };
    let additionalData = {
      applicantName: `${data.Applicants.firstName} ${data.Applicants.lastName}`,
      currentWorking: {
        designation: designation,
        from: getWorkonDate(expObject, "level2"),
      },
      emailId: data.Applicants?.emailId,
      contactNumber: data.Applicants?.contactNumber || data.Applicants?.phone,
      alternateContactNumber: data.Applicants?.alternateContactNumber || "",
      linkedIn: data.linkedIn ?? "",
      location: data?.formattedLocation?.trim() ||
            [data?.locationCity, data?.locationState, data?.locationCountry]
              .filter(Boolean).join(", "),
    };
    setBreadCrumb(
      getJobCode,
      additionalData.applicantName,
      "Applicant Code",
      additionalData,
    );
  };

  useEffect(() => {
    if (Editdata === 200 && !PrimaryDocumentRes) {
      dispatch(_ser.editApplicantsStartReducer(initalState));
      dispatch(_ser.applicantsByIdStartReducer(initalState));
      dispatch(refreshOutlet());
      if (!selectedJobDetails) {
        setTimeout(() => {
          navigate(`/ats/layout/applicants/view/${getJobCode}`);
        }, 1000);
      }
    } else if(PrimaryDocumentRes === 200){
      localStorage.removeItem("OverwriteEditObj");
      navigate(`/ats/layout/applicants/documents/${getJobCode}`);
      dispatch(_ser.setPrimaryDocumentStartReducer(initalState));
    }
  }, [Editdata, PrimaryDocumentRes]);

  const processApplicantjobs = async (docId) => {
      if (
        docId &&
        !location.state?.isAssociatedApplicant &&
        selectedJobDetails?.length > 0
      ) {
        let userInfo = await GetUserInfo();
        let userId = await getAttributes();

        let data = {
          id: getJobCode,
          jobCode: selectedJobDetails[0].jobCode,
          docId: docId,
          firstName: userId[0].firstName,
          lastName: userId[0].lastName,
          portalassociatedJobs: "associatedJobs",
          status: "Associated",
          source: "ATS",
          submittedBy: userInfo[0].userId,
          userId: userId[0].userId,
        };
        let jobs = [];
        if (selectedJobDetails && selectedJobDetails.length > 0) {
          selectedJobDetails.forEach((job) => {
            let obj = {};
            obj["jobId"] = job.id;
            obj["jobCode"] = job.jobCode;
            jobs.push(obj);
          });
        }
        data["jobs"] = jobs.length > 0 ? jobs : [];
        dispatch(_ser.addAssociatedjobsAsync(getJobCode, data, "posting"));
        dispatch(_ser.setSelectedJobDetailsStartReducer(initalState));
        setTimeout(() => {
          localStorage.removeItem("OverwriteEditObj");
          navigate(`/ats/layout/applicants/view/${getJobCode}`);
        }, 1500);
        dispatch(_ser.uploadDocumentsStartReducer(initalState));
      }
    }

  useEffect(() => {
    if(DocId){
      processApplicantjobs(DocId);
    }
  }, [DocId]);

  const actionBtns = [
    {
      variant: "text",
      style: { color: "red", width: "6rem", fontWeight: "bolder" },
      navigateTo:
        overwrideObj !== null
          ? "/ats/layout/applicants/landing"
          : `/ats/layout/applicants/view/${getJobCode}`,
      label: "Cancel",
      type: "back",
      class: "buttonHover",
    },
    {
      variant: "contained",
      style: {
        backgroundColor: "var(--primary-bg-color)",
        color: "var(--primary-background-text-color)",
        borderRadius: "10px",
        width: "6rem",
        fontSize: "14px",
      },
      navigateTo: null,
      label: "Save",
      type: "submit",
      class: "buttonHover1",
    },
  ];

  return (
    <React.Fragment>
      <div style={{ padding: "0 10px" }} id="applicantsView">
        <ApplicantsComponent
          componentType="Edit"
          input={getDetails}
          iniValue={initialDetails}
          actions={actionBtns}
          onValidData={GetValidData}
          disableSubmitBtn={disableSubmitBtn}
        />
      </div>
    </React.Fragment>
  );
};

export default ApplicantsEdit;

const initialDetails = {
  Applicants: {
    firstName: "",
    lastName: "",
    contactNumber: "",
    alternateContactNumber: "",
    emailId: "",
  },
  educationDetails: [
    { id: "", education: "", startDate: null, endDate: null, location: "" },
  ],
  workExp: [
    {
      id: "",
      organization: "",
      jobTitle: "",
      industry: "",
      startDate: null,
      endDate: null,
      isCurrent: "",
      location: "",
      jobDescription: "",
    },
  ],
  formattedLocation: null,
  locationCity: null,
  locationCountry: null,
  locationState: null,
  locationRawInput: null,
  latitude: null,
  longitude: null,
  skillDetails: [],
  certification: [],
  totalExperience: null,
  linkedIn: "",
  id: 0,
  userId: "",
  customFields: "",
  firstName: "",
  lastName: "",
  identifier: "",
  applicantCode: "",
  customerId: 0,
  source: "ATS",
  resumesourceId: "",
  candidateStatus: "",
  applicantCode: "",
  csAssociatedJobs: "",
  eAssociatedJobs: "",
  vsAssociatedJobs: "",
  Resume: null,
  rawData: "",
};
